import { render, staticRenderFns } from "./index.vue?vue&type=template&id=188118a9&"
import script from "./index.js?vue&type=script&lang=javascript&"
export * from "./index.js?vue&type=script&lang=javascript&"
import style0 from "./style.scss?vue&type=style&index=0&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports